<template>
  <div
    v-if="visible"
    class="cookie-banner"
    :class="{ detail: detail }"
    role="dialog"
    aria-label="Cookie-Einstellungen"
  >
    <div class="cb-head">
      <VibelaMark :size="24" />
      <div class="cb-title">
        {{ detail ? 'Cookie-Einstellungen' : 'Cookies, aber mit Geschmack.' }}
      </div>
    </div>

    <template v-if="detail">
      <p class="cb-body">Wähle, welche Kategorien wir laden dürfen.</p>
      <div class="cb-cats">
        <div v-for="cat in categories" :key="cat.id" class="cb-cat">
          <div class="cb-cat-row">
            <div class="cb-cat-name">{{ cat.name }}</div>
            <label
              class="cb-toggle"
              :class="{ on: consent[cat.id], disabled: cat.required }"
            >
              <input
                type="checkbox"
                :checked="consent[cat.id] || false"
                :disabled="cat.required"
                @change="onToggle(cat.id, $event.target.checked)"
              />
              <span class="cb-knob"></span>
            </label>
          </div>
          <p class="cb-cat-desc">{{ cat.desc }}</p>
        </div>
      </div>
      <div class="cb-actions">
        <button class="btn btn-primary cb-cta" type="button" @click="saveSelection">
          Auswahl speichern
        </button>
        <button class="cb-text-link" type="button" @click="detail = false">
          Zurück
        </button>
      </div>
    </template>

    <template v-else>
      <p class="cb-body">
        Wir nutzen Cookies für das Nötigste und (mit deinem OK) für bessere
        Empfehlungen. Mehr in unserer
        <a href="/datenschutz">Datenschutzerklärung</a>.
      </p>
      <div class="cb-actions">
        <button class="btn btn-primary cb-cta" type="button" @click="acceptAll">
          Alle akzeptieren
        </button>
        <button class="btn btn-ghost cb-cta" type="button" @click="acceptNecessary">
          Nur Notwendige
        </button>
        <button class="cb-text-link" type="button" @click="detail = true">
          Anpassen
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import VibelaMark from './VibelaMark.vue';

const COOKIE_KEY = 'vibela_cookies';
const COOKIE_CATEGORIES = [
  {
    id: 'notwendig',
    name: 'Notwendig',
    required: true,
    desc: 'Login, Spracheinstellung, Sicherheits-Cookies. Ohne diese funktioniert die Seite nicht.',
  },
  {
    id: 'funktional',
    name: 'Funktional',
    required: false,
    desc: 'Komfort-Features: gespeicherte Suchen, Theme-Präferenz, Tooltip-Status.',
  },
  {
    id: 'analyse',
    name: 'Analyse',
    required: false,
    desc: 'Google Analytics (GA4). Hilft uns zu verstehen, was funktioniert.',
  },
  {
    id: 'marketing',
    name: 'Marketing',
    required: false,
    desc: 'Falls wir mal Werbung schalten — relevant statt zufällig.',
  },
];

function loadConsent() {
  try {
    const raw = localStorage.getItem(COOKIE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export default {
  name: 'CookieBanner',
  components: { VibelaMark },
  data() {
    return {
      visible: false,
      detail: false,
      categories: COOKIE_CATEGORIES,
      consent: {
        notwendig: true,
        funktional: false,
        analyse: false,
        marketing: false,
      },
    };
  },
  created() {
    const saved = loadConsent();
    if (saved) {
      window.__vibelaConsent = saved;
    } else {
      this.visible = true;
    }

    // Re-open the banner (in detail mode) from the footer "Cookie-Einstellungen" link.
    window.__vibelaShowCookieBanner = () => {
      const current = loadConsent();
      if (current) {
        this.consent = { ...this.consent, ...current };
      }
      this.visible = true;
      this.detail = true;
    };
  },
  beforeDestroy() {
    delete window.__vibelaShowCookieBanner;
  },
  methods: {
    saveConsent(value) {
      try {
        localStorage.setItem(
          COOKIE_KEY,
          JSON.stringify({ ...value, ts: Date.now() })
        );
      } catch (e) {
        // Ignore storage failures (private mode, quota exceeded).
      }
      window.__vibelaConsent = value;
      window.dispatchEvent(new CustomEvent('vibela:consent', { detail: value }));
    },
    onToggle(id, checked) {
      this.consent = { ...this.consent, [id]: checked };
    },
    acceptAll() {
      this.saveConsent({
        notwendig: true,
        funktional: true,
        analyse: true,
        marketing: true,
      });
      this.visible = false;
    },
    acceptNecessary() {
      this.saveConsent({
        notwendig: true,
        funktional: false,
        analyse: false,
        marketing: false,
      });
      this.visible = false;
    },
    saveSelection() {
      this.saveConsent(this.consent);
      this.visible = false;
    },
  },
};
</script>
